import Plot from "react-plotly.js";
import { useMemo } from "react";
import { premiumLayout, premiumConfig, premiumPalette } from "./plotTheme";

function safeArray(x) {
  return Array.isArray(x) ? x : [];
}

export default function LinePlot({ title = "", points, yLabel = "" }) {
  const safePoints = safeArray(points);

  // Normaliza: soporta {date, value} o {x, y} o {ts, v}
  const { x, y } = useMemo(() => {
    const xs = [];
    const ys = [];
    for (const p of safePoints) {
      const px = p?.date ?? p?.x ?? p?.ts ?? p?.day ?? null;
      const py = p?.value ?? p?.y ?? p?.v ?? null;
      if (px == null || py == null) continue;
      xs.push(px);
      ys.push(py);
    }
    return { x: xs, y: ys };
  }, [safePoints]);

  const data = useMemo(
    () => [
      {
        type: "scatter",
        mode: "lines",
        x,
        y,
        name: title || "series",
        line: { width: 3, color: premiumPalette.yes }, // reutilizo el color “tech”
        hovertemplate: "<b>%{x}</b><br>%{y}<extra></extra>",
      },
    ],
    [x, y, title]
  );

  const layout = useMemo(() => {
    const L = premiumLayout();
    return {
      ...L,
      height: 320,
      margin: { l: 52, r: 14, t: 10, b: 52 },
      xaxis: {
        ...L.xaxis,
        automargin: true,
        tickangle: 0,
      },
      yaxis: {
        ...L.yaxis,
        title: yLabel ? { text: yLabel, standoff: 10 } : undefined,
        rangemode: "tozero",
      },
      showlegend: false,
    };
  }, [yLabel]);

  return (
    <div className="min-w-0 rounded-2xl border border-slate-200/70 bg-white shadow-[0_1px_0_rgba(15,23,42,0.04),0_8px_24px_rgba(15,23,42,0.08)] p-4">
      <div className="text-sm font-semibold text-slate-900">{title}</div>
      <div className="min-w-0 mt-2">
        <Plot
          data={data}
          layout={layout}
          config={premiumConfig}
          useResizeHandler
          style={{ width: "100%" }}
        />
      </div>
    </div>
  );
}